import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { AdminGuard } from './core/guards/admin.guard';
import { PermissionsGuardFactory, temporaryExcludedModuleGuard } from './core/guards/permissions.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'users',
    loadChildren: () => import('./features/users/users.routes').then(m => m.routes),
    canActivate: [AuthGuard]
  },
  {
    path: 'companies',
    loadChildren: () => import('./features/companies/companies.routes').then(m => m.routes),
    canActivate: [AuthGuard]
  },
  {
    path: 'support-tickets',
    loadChildren: () => import('./features/support-tickets/support-tickets.routes').then(m => m.routes),
    canActivate: [AuthGuard, temporaryExcludedModuleGuard('support-tickets')]
  },
  {
    path: 'bills',
    loadChildren: () => import('./features/bill/bill.routes').then(m => m.billRoutes),
    canActivate: [AuthGuard]
  },
  {
    path: 'reconciliation',
    loadChildren: () => import('./features/reconciliation/reconciliation.routes').then(m => m.reconciliationRoutes),
    canActivate: [AuthGuard]
  },
  {
    path: 'bulk-upload',
    loadChildren: () => import('./features/bulk-upload/bulk-upload.routes').then(m => m.bulkUploadRoutes),
    canActivate: [AuthGuard]
  },
  {
    path: 'account',
    loadComponent: () => import('./features/account/account.component').then(m => m.AccountComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'empresas',
    loadComponent: () => import('./features/empresas/empresas.component').then(m => m.EmpresasComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'usuarios/lista',
    loadComponent: () => import('./features/users/user-list/user-list.component').then(m => m.UserListComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'usuarios/fichaUsuario',
    loadComponent: () => import('./features/users/user-ficha/user-ficha.component').then(m => m.UserFichaComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'usuarios',
    loadComponent: () => import('./features/usuarios/usuarios.component').then(m => m.UsuariosComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'informes',
    loadComponent: () => import('./features/informes/informes.component').then(m => m.InformesComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'politicas',
    loadComponent: () => import('./features/politicas/politicas.component').then(m => m.PoliticasComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'configuracion',
    loadComponent: () => import('./features/configuracion/configuracion.component').then(m => m.ConfiguracionComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'variables',
    loadComponent: () => import('./features/variables/variables.component').then(m => m.VariablesComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'access',
    loadComponent: () => import('./features/access/access.component').then(m => m.AccessComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'widget-rendidor',
    loadChildren: () => import('./features/widget-rendidor/widget-rendidor.routes').then(m => m.routes),
    canActivate: [AuthGuard]
  },
  {
    path: 'emails',
    loadComponent: () => import('./features/emails/emails.component').then(m => m.EmailsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'email-mkt',
    loadComponent: () => import('./features/email-mkt/email-mkt.component').then(m => m.EmailMktComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'reportes',
    loadComponent: () => import('./features/reportes/reportes.component').then(m => m.ReportesComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'nps',
    loadChildren: () => import('./features/nps/nps.routes').then(m => m.routes),
    canActivate: [AuthGuard]
  },
  {
    path: 'tickets',
    loadComponent: () => import('./features/tickets/tickets.component').then(m => m.TicketsComponent),
    canActivate: [AuthGuard, temporaryExcludedModuleGuard('support-tickets')]
  },
  {
    path: 'admin',
    loadChildren: () => import('./features/admin/admin.routes').then(m => m.adminRoutes),
    canActivate: [AuthGuard]
  },
  {
    path: 'bugs',
    loadChildren: () => import('./features/bugs/bugs.routes').then(m => m.bugsRoutes),
    canActivate: [AuthGuard, AdminGuard]
  },
  {
    path: 'site-panel-demo',
    loadComponent: () => import('./features/demo/site-panel-demo.component').then(m => m.SitePanelDemoComponent),
    canActivate: [AuthGuard]
  },
    {
      path: 'logs',
      loadComponent: () => import('./features/logs/components/logs/logs.component').then(m => m.LogsComponent),
      canActivate: [AuthGuard]
    },
    {
      path: 'permissions',
      loadChildren: () => import('./features/permissions/permissions.routes').then(m => m.permissionsRoutes),
      canActivate: [AuthGuard, AdminGuard]
    },
    {
      path: 'diagnostic-logs',
      redirectTo: '/infra/diagnostic-logs',
      pathMatch: 'full'
    },
    {
      path: 'integrations-catalog',
      loadChildren: () => import('./features/integrations-catalog/integrations-catalog.routes').then(m => m.integrationsCatalogRoutes),
      canActivate: [AuthGuard, PermissionsGuardFactory('integrations')]
    },
    {
      path: 'specimen',
      loadComponent: () => import('./features/specimen/specimen.component').then(m => m.SpecimenComponent),
      canActivate: [AuthGuard]
    },
    {
      // PLAN-011 Fase 8 — Catálogo vivo del Design System
      path: 'dev/design-system',
      loadComponent: () => import('./features/dev-design-system/dev-design-system.component').then(m => m.DevDesignSystemComponent),
      canActivate: [AuthGuard]
    },
    {
      path: 'infra',
      loadChildren: () => import('./features/infra/infra.routes').then(m => m.routes),
      canActivate: [AuthGuard, AdminGuard, temporaryExcludedModuleGuard('infra')]
    },
    {
      path: '**',
      redirectTo: '/dashboard'
    }
];
